/**
 * Rozo Analytics — Event Catalog (sep24-reference-ui)
 *
 * Convention: {domain}_{action} — snake_case, no abbreviations.
 * Never rename existing events — add new ones instead.
 *
 * All events share these base properties (injected automatically):
 *   app_name   — "rozoanchor-sep24-reference-ui"
 *   $current_url, $pathname — injected by PostHog SDK
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// ---------------------------------------------------------------------------
// Global — shared across Rozo apps
// ---------------------------------------------------------------------------
export var GLOBAL_EVENTS = {
    PAGE_VIEWED: "page_viewed",
    ERROR_OCCURRED: "error_occurred",
};
// ---------------------------------------------------------------------------
// Payment domain — shared across Rozo apps
// ---------------------------------------------------------------------------
export var PAYMENT_EVENTS = {
    PAYMENT_FLOW_STARTED: "payment_flow_started",
    PAYMENT_SUBMITTED: "payment_submitted",
    PAYMENT_COMPLETED: "payment_completed",
    PAYMENT_FAILED: "payment_failed",
};
// ---------------------------------------------------------------------------
// SEP-24 domain — app-specific
// ---------------------------------------------------------------------------
export var SEP24_EVENTS = {
    /** KYC/amount form shown to user, with trustline/balance context */
    KYC_FORM_VIEWED: "kyc_form_viewed",
    /** Client-side validation failed on submit */
    KYC_VALIDATION_FAILED: "kyc_validation_failed",
    /** Resumed KYC flow from a /txn wallet link (transaction was incomplete) */
    KYC_BOOTSTRAP_REDIRECT: "kyc_bootstrap_redirect",
    /** Transaction reached "expired" status or countdown hit zero */
    TRANSACTION_EXPIRED: "transaction_expired",
    /** Status update received via Pusher or polling */
    STATUS_UPDATE_RECEIVED: "status_update_received",
    /** Callback dispatched back to wallet (postMessage / URL POST / deeplink) */
    WALLET_CALLBACK_SENT: "wallet_callback_sent",
    /** Deposit funding address copied to clipboard */
    DEPOSIT_ADDRESS_COPIED: "deposit_address_copied",
    /** Withdrawal destination address copied to clipboard */
    WITHDRAWAL_ADDRESS_COPIED: "withdrawal_address_copied",
    /** Deposit QR mode toggled between deeplink/address */
    DEPOSIT_QR_MODE_CHANGED: "deposit_qr_mode_changed",
    /** Deposit wallet deeplink opened */
    DEPOSIT_DEEPLINK_OPENED: "deposit_deeplink_opened",
    /** Block explorer link clicked */
    EXPLORER_LINK_CLICKED: "explorer_link_clicked",
};
// ---------------------------------------------------------------------------
// All events — flat union for type safety
// ---------------------------------------------------------------------------
export var ROZO_EVENTS = __assign(__assign(__assign({}, GLOBAL_EVENTS), PAYMENT_EVENTS), SEP24_EVENTS);
export var ROZO_APP_NAME = "rozoanchor-sep24-reference-ui";
